/* eslint-disable jsx-a11y/no-autofocus */
import React from 'react';
import classnames from 'classnames';

export interface TextAreaProps extends React.HTMLAttributes<HTMLElement> {
  className?: string;
  rows?: number;
  maxLength?: number;
}

const TextArea: React.FunctionComponent<TextAreaProps> = ({
  className,
  rows = 4,
  maxLength = 240,
  ...props
}) => (
  <textarea
    className={classnames('input__textarea', 'input__control', className)}
    rows={rows}
    maxLength={maxLength}
    {...props}
  />
);

export default TextArea;
